<template>
  <v-file-input @change='setFile' outlined dense :label="item.Attachment ? item.Attachment.Name : 'Загрузить файл'" />
</template>

<script>
import { fileService } from '~/services/FileNextNumberService'
import { coreApi } from '~/services/core'

export default {
  props: {
    supplier: Object,
    item: Object
  },
  name: 'File',
  methods: {
    async setFile(file) {
      const data = this.supplier
      if (file) {
        const fileId = await fileService.generateId()
        const res = await fileService.upload(fileId.data.Id, file)
        this.item.Attachment = res.data
      }
      await coreApi.put('suppler', data)
    }
  }
}

</script>

<style scoped>

</style>